import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'home-fitness-challenge-list',
  templateUrl: './home-fitness-challenge-list.component.html',
  styleUrls: ['./home-fitness-challenge-list.component.scss']
})
export class HomeFitnessChallengeListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
